export default __webpack_public_path__ + "static/media/sushi.6b0ec0ba.jpg";